import { createSlice } from "@reduxjs/toolkit";
import lang from "../assets/lang/icons.json";

const initialState = {
  currentFeature: [
    {
      currentFeature: "",
    },
  ],
};

export const featuresSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    currentFeature: (state, action) => {
      if (action.payload === "") {
        state.currentFeature = [];
        state.currentFeature = [
          ...state.currentFeature,
          initialState.currentFeature[0],
        ];
      } else {
        const currentFeature = action.payload;
        state.currentFeature = [];
        state.currentFeature = [...state.currentFeature, { currentFeature }];
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { currentFeature } = featuresSlice.actions;

export default featuresSlice.reducer;
